// @flow
import React from 'react';
import i18n from 'i18n-js';

import { api } from '../../api';
import UserResult from '../UserResult';
import BusResult from '../BusResult';
import RouteResult from '../RouteResult';
import RouteStopResult from '../RouteStopResult';
import GateResult from '../GateResult';
import {
  // USER_RESULT_TYPE,
  STUDENT_RESULT_TYPE,
  PARENT_RESTULT_TYPE,
  ROUTE_RESULT_TYPE,
  BUS_RESULT_TYPE,
  ROUTE_STOP_RESULT_TYPE,
  GATE_RESULT_TYPE,
} from './types';
import { getUserImage } from '../../utils';


type ResultType = {
  result_type: string,
  id: number,
  isSelected?: boolean,
  size?: string,
  onClick?: Function,
  code_name: string,
  first_name: string,
  name: string,
  last_name: string,
  profiles: Array<string>,
  plates: string,
  expected_passenger_number: number,
  profile_picture: string,
};


class OmnisearchResult extends React.PureComponent<ResultType> {
  render() {
    const { result_type } = this.props;
    switch (result_type) {
      case BUS_RESULT_TYPE: {
        const {
          code_name,
          plates,
          isSelected,
          onClick,
          size,
        } = this.props;

        return (
          <BusResult
            name={code_name}
            plates={`Placas: ${plates}`}
            isSelected={isSelected}
            size={size}
            onClick={onClick}
          />
        );
      }
      case GATE_RESULT_TYPE: {
        const {
          name,
          isSelected,
          onClick,
          size,
        } = this.props;

        return (
          <GateResult
            name={name}
            isSelected={isSelected}
            size={size}
            onClick={onClick}
          />
        );
      }
      case ROUTE_RESULT_TYPE: {
        const {
          name,
          expected_passenger_number = 0,
          isSelected,
          size,
          onClick,
        } = this.props;
        return (
          <RouteResult
            name={name}
            passengers={expected_passenger_number}
            isSelected={isSelected}
            size={size}
            onClick={onClick}
          />
        );
      }
      case ROUTE_STOP_RESULT_TYPE: {
        const {
          name,
          expected_passenger_number = 0,
          isSelected,
          size,
          onClick,
          routeName,
        } = this.props;
        return (
          <RouteStopResult
            name={name} 
            passengers={expected_passenger_number}
            isSelected={isSelected}
            size={size}
            onClick={onClick}
            routeName={routeName}
          />
        );
      }
      case STUDENT_RESULT_TYPE: {
        const {
          id,
          code = i18.t('labels.none'),
          first_name,
          last_name,
          profiles = [],
          profile_picture,
          isSelected,
          size,
          onClick,
        } = this.props;
        return (
          <UserResult
            firstName={first_name}
            lastName={last_name}
            userId={`${i18n.t('labels.code')}: ${code}`}
            // pictureURL={api.getURL(`users/${id}/profile-picture`)}
            pictureURL={getUserImage(profile_picture)}
            isSelected={isSelected}
            size={size}
            onClick={onClick}
          />
        );
      }
      case PARENT_RESTULT_TYPE: {
        const {
          id,
          first_name,
          last_name,
          profiles = [],
          profile_picture,
          isSelected,
          size,
          onClick,
        } = this.props;
        return (
          <UserResult
            firstName={first_name}
            lastName={last_name}
            userRole={profiles.length > 0 ? profiles[0] : 'Parent'}
            // pictureURL={api.getURL(`users/${id}/profile-picture`)}
            pictureURL={getUserImage(profile_picture)}
            isSelected={isSelected}
            size={size}
            onClick={onClick}
          />
        );
      }
      case null || undefined: {
        return <div />;
      }
      default: {
        const {
          id,
          first_name,
          last_name,
          profiles = [],
          profile_picture,
          isSelected,
          size,
          onClick,
        } = this.props;
        return (
          <UserResult
            firstName={first_name}
            lastName={last_name}
            userRole={profiles.length > 0 ? profiles[0] : 'Usuario'}
            // pictureURL={api.getURL(`users/${id}/profile-picture`)}
            pictureURL={getUserImage(profile_picture)}
            isSelected={isSelected}
            size={size}
            onClick={onClick}
          />
        );
      }
    }
  }
}

export default OmnisearchResult;



// WEBPACK FOOTER //
// ./src/scripts/components/OmnisearchResult/index.jsx